<template>
<div class="container">
    <core-header :user="user"></core-header>
    <core-nav-main :user="user"></core-nav-main>
    <dashboard-header
        :showMode="showMode"
        @toggleShowMode="toggleShowMode"
        :isActivePay="user.active_pay" />
    <div class="dashboard" v-if="ready">
        <div class="ql-dashboard-top">
            <div class="container">
                <md-layout md-row v-if="mostRecentProject || userPendingInvites.length > 0" md-flex="60">
                    <md-layout md-align="center" md-row>
                        <md-button class="md-raised md-accent btn-start-project" @click="openCreateProject()">Start a New Project</md-button>
                    </md-layout>
                    <md-layout md-flex="100" class="layout-separator"></md-layout>
                    <md-layout md-flex="100" md-row md-gutter="16" md-align="center">
                        <md-layout v-if="mostRecentProject" md-flex="50">
                            <dashboard-project-box :project="mostRecentProject"/>
                        </md-layout>
                        <md-layout v-if="mostRecentProject || userPendingInvites.length > 0" md-flex="50">
                            <dashboard-pending-projects :projects="userPendingInvites" :user="user"/>
                        </md-layout>
                    </md-layout>
                </md-layout>
                <md-layout md-row v-else md-vertical-align="center" md-align="center">
                    <md-layout md-align="center" md-row>
                        <md-button class="md-raised md-accent btn-start-project" @click="openCreateProject()">Start your first Project</md-button>
                    </md-layout>
                    <md-layout md-flex="100" class="layout-separator"></md-layout>
                </md-layout>
            </div>
        </div>
        <md-layout md-row v-if="displayProjects.length" md-flex="40">
            <dashboard-project-grid :projects="displayProjects"/>
        </md-layout>
    </div>
    <div class="dashboard" v-else>
        <md-layout md-row md-flex="100" md-vertical-align="center" md-align="center">
            <span class="md-subheader">Loading your projects...</span>
        </md-layout>
        
    </div>
    <!-- Project Creation Modal -->
    <create-project ref="createProject"></create-project>
    <core-footer></core-footer>
</div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

import Vue from 'vue';

import CoreNavMain from '@/components/core/nav/main';
import CoreHeader from '@/components/core/header';
import CoreFooter from '@/components/core/footer';
import DashboardHeader from '@/components/dashboard/header';
import DashboardProjectBox from '@/components/dashboard/project-box';
import DashboardProjectGrid from '@/components/dashboard/project-grid';
import DashboardHistoryBox from '@/components/dashboard/history-box';
import DashboardPendingProjects from '@/components/dashboard/pending-projects';
import CreateProject from '@/modals/create-project';

const DashboardView = {
    name: 'dashboard',
    data: function() {
        return {
            // projectsRef: firebase.database().ref('projects/')
            ready: false,
            theme: 'default'
        };
    },
    watch: {
        projects: function() {
            if (this.projects) {
                this.ready = true;
            }
        }
    },
    computed: {
        ...mapGetters([
            'projects',
            'mostRecentProject',
            'userProjects',
            'userPendingInvites',
            'user',
            'showMode'
        ]),
        displayProjects: function() {
            return this.userProjects.filter((proj) => {
                return proj.id !== this.mostRecentProject.id;
            });
        }
    },
    methods: {
        toggleShowMode() {
            // this.showMode = !this.showMode;
            this.$store.dispatch('updateShowMode', !this.showMode);
            if (this.showMode) {
                this.theme = 'show-mode';
            } else {
                this.theme = 'default';
            }
            Vue.material.setCurrentTheme(this.theme);
        },
        openCreateProject() {
            this.$refs.createProject.open();
        }
    },
    components: {
        'core-nav-main': CoreNavMain,
        'core-header': CoreHeader,
        'core-footer': CoreFooter,
        'dashboard-header': DashboardHeader,
        'dashboard-project-box': DashboardProjectBox,
        'dashboard-project-grid': DashboardProjectGrid,
        'dashboard-history-box': DashboardHistoryBox,
        'dashboard-pending-projects': DashboardPendingProjects,
        'create-project': CreateProject
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            vm.$store.dispatch('setProjectsRef', {
                ref: firebase.database().ref('projects'),
                options: {}
            });
            vm.$store.dispatch('setUsersRef', {
                ref: firebase.database().ref('users'),
                options: {}
            });
            vm.$store.dispatch('setActiveUser', {
                ref: firebase.database().ref(`users/${firebase.auth().currentUser.uid}`),
                options: { readyCallback: () => {} }
            });
        });
    }
};
export default DashboardView;
</script>

<style lang="scss">
.dashboard {
    min-height: calc(100% - 64px);
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding-left: 16px;
    margin-bottom: 30px;
    .md-gutter-16 {
        margin-top: 8px;
    }
    .ql-dashboard-container-top {
        height: 60%;
        width: 100%;
        display: block;
    }
    .ql-dashboard-top {
        margin-top: -24px;
    }
    .btn-start-project {
        background: #5ecfdf !important;
        // color: #000 !important;
    }
}
</style>


// WEBPACK FOOTER //
// dashboard.vue?2c522552